import { Moment } from 'moment';
import { ProviderService } from '../api/Providers/Services';

export enum ProviderPlan {
  Deluxe = 'deluxe',
  Commission = 'commission',
}

export interface ISerializedPromotion {
  best_services: number[],
  client_redemption_limit: number,
  creation_time: string | null,
  description: string,
  disabled_time: string | null,
  discount_quantity: string, // always a floating point number as a string
  discount_type: 'percentage' | 'flat-rate',
  discount_formatted: string,
  book_end_time: string,
  id: number | null,
  name: string | null,
  provider,
  services: ProviderService[] | number[] | null,
  book_start_time: string,
  modification_time: string | null,
}

export interface IProviderServicePromotion {
  best_services: any[],
  client_redemption_limit: number,
  creation_time: Moment | null,
  description: string,
  disabled_time: null | Moment,
  discount_quantity: number,
  discount_type: 'percentage' | 'flat-rate',
  discount_formatted: string,
  book_end_time: Moment,
  id: number | null,
  name: string | null,
  provider,
  services: ProviderService[] | null,
  book_start_time: Moment,
  modification_time: null | Moment,
  getFormattedDiscount: () => string,
  getPromotionalPrice: (cost: number) => number,
  getSerializedObject: () => Omit<ISerializedPromotion, 'creation_time' | 'modification_time'>,
  isCurrent: () => boolean,
  isFuture: () => boolean,
  isPast: () => boolean,
  isStopped: () => boolean,
  isDeleted: () => boolean,
}

export type SubsetOfFieldsFromPromotion<Y extends keyof IProviderServicePromotion> = (
  Pick<IProviderServicePromotion, Y>
);

export type ProviderServicePromotionsByService = {
  [id: number]: IProviderServicePromotion[],
};
